import Handlebars from 'handlebars/runtime.js';

(function ($) {
  'use strict';

  // [REFACTOR NOTE] Reason: Redundancy
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  window.hasOwnProperty = hasOwnProperty; // jshint ignore:line

  function getAnswer(name) {
    return page_state.form_data[name];
  }
  window.getAnswer = getAnswer;

  function getDeepProperty(object, propertyList) {
    if (!object) {
      return;
    }

    var length = propertyList.length;
    var result = object;

    for (var i = 0; i < length; i++) {
      if (typeof result === 'object' && propertyList[i] in result) {
        result = result[propertyList[i]];
      } else {
        return;
      }
    }

    return result;
  }
  window.getDeepProperty = getDeepProperty;

  var helpers = {
    /**
     * Get an answer from the form data.
     * @param {string} name The question id.
     * @param {string} [value] The question id modifier. Tries to access
     *     <name>-<value> key, falling back to <name> if it's falsey.
     * Note: this will not work as a block helper.
     */
    answer: function (name, value) {
      var result = getAnswer(name + '-' + String(value));
      return result || getAnswer(name);
    },
    /**
     * Returns the passed-in answer if not `null` or `undefined`, otherwise
     * defers to the `answer` helper.
     * @param {*} answer Current value of questionnaire variable.
     * @param {string} name The question id.
     * @param {string} [value] The question id modifier. Tries to access
     *     <name>-<value> key, falling back to <name> if it's falsey.
     */
    ans: function (answer, name, value) {
      if (answer == null) {
        return helpers.answer.call(this, name, value);
      }

      return answer;
    },
    getFirstObjectValue: function (object) {
      return object[Object.keys(object).shift()];
    },
    getFirstObjectKey: function (object) {
      return Object.keys(object).shift();
    },
    getLastObjectValue: function (object) {
      return object[Object.keys(object).pop()];
    },
    getLastObjectKey: function (object) {
      return Object.keys(object).pop();
    },
    /**
     * Argh. Wrapper around ifanswer so that it also makes use of passed-in
     * answers. Defers to ifanswer if passed null.
     * @param {*} answer Current value of questionnaire variable.
     * @param {string} name Form input name.
     * @param {(string|number)} value The value to check the answer against.
     * @param {Object} options The options object passed in by Handlebars.
     */
    ifans: function (answer, name, value, options) {
      if ($.isArray(answer) && $.inArray(value, answer) !== -1)
        return options.fn(this);

      if (value === answer) return options.fn(this);

      return helpers.ifanswer.call(this, name, value, options);
    },
    ifanswer: function (name, value, options) {
      if (
        // If it's a regular single code grid, and the result is
        // the given value.
        getAnswer(name) === String(value) ||
        getAnswer(name) === 'on' ||
        getAnswer(name + '-' + String(value))
      ) return options.fn(this);

      return options.inverse(this);
    },
    /**
     * Conditional to check whether or not there's an answer at all.
     * @param {string} name The input name to check for.
     */
    ifanswerexists: function (name, options) {
      if (name in page_state.form_data)
        return options.fn(this);
      else
        return options.inverse(this);
    },
    /**
     * Compare a ``first-last`` named answer's value to ``value``.
     * This use case isn't covered by ifanswer, which is already overloaded
     * enough.
     * @param {string} first The first part of the answer's name, e.g., ``id``.
     * @param {string} last The last part of the answer's name, e.g., ``code``.
     * @param {(string|number)} value The value to check the answer against.
     * @param {Object} options The options object passed in by Handlebars.
     */
    ifansweris: function (first, last, value, options) {
      var answer = getAnswer(first + '-' + last);
      if (answer === value) {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    },
    /**
     * Set properties on the given context via the options hash. Note that
     * this will *mutate* the object originally passed into the template!
     *
     * This is useful, for instance, for making a parent loop's private @index
     * variable available within a nested loop. For example:
     *
     *     {{#each items}}
     *     {{set this parent_index=@index}}
     *     {{#each subitems}}
     *     subitem index: {{@index}}, item index: {{../parent_index}}
     *     {{/each}}
     *     {{/each}}
     */
    set: function (context, options) {
      $.extend(context, options.hash);
    },
    startsWith: function (text, value, options) {
      return text.indexOf(value) === 0
        ? options.fn(this)
        : options.inverse(this);
    },
    unlessanswer: function (name, value, options) {
      if (
        // If it's a regular single code grid, and the result is
        // the given value.
        getAnswer(name) === String(value) ||
        getAnswer(name) === 'on' ||
        getAnswer(name + '-' + String(value))
      ) return options.inverse(this);

      return options.fn(this);
    },
  };
  window.helpers = { ...window.helpers, ...helpers };

  // Attach all the helper functions to the Handlebars namespace.
  for (var name in helpers) {
    if (hasOwnProperty.call(helpers, name))
      Handlebars.registerHelper(name, helpers[name]);
  }
})(jQuery);
